module.exports = __webpack_public_path__ + "img/BRN.ec461edd.gif";